// Backgrounds
const primaryBackgroundColorOne = '#FFFFFF';
const primaryBackgroundColorTwo = '#EFF1F6';
const secondaryBackgroundColorOne = '#E9F0FE';
const secondaryBackgroundColorTwo = '#F8FBFF';
const tertiaryBackgroundColorOne = '#FFFFB7';
const tertiaryBackgroundColorTwo = '#FFFDF5';
const tertiaryBackgroundColorThree = '#FAF1E0';
const tertiaryBackgroundColorFour = '#FFFDF5';
const quaternaryBackgroundColorOne = '#0012F0';

// Text Colors
const primaryTextColorOne = '#0012F0';
const primaryTextColorTwo = '#1F37F6';
const primaryTextColorThree = '#4764FA';
const secondaryTextColorOne = '#221C23';
const secondaryTextColorTwo = '#333231';
const tertiaryTextColorOne = '#555452';
const tertiaryTextColorTwo = '#3A343B';
const tertiaryTextColorThree = '#333231';
const tertiaryTextColorFour = '#444444';
const tertiaryTextColorFive = '#666666';

// Borders
const primaryBorderColorOne = '#878787';
const primaryBorderColorTwo = '#F1EEEA';
const primaryBorderColorThree = '#CCCCCC';

// Transparent
const transparent = 'rgba(0, 0, 0, 0)';

export {
    primaryTextColorThree,
    secondaryBackgroundColorOne,
    primaryTextColorTwo,
    primaryTextColorOne,
    secondaryBackgroundColorTwo,
    tertiaryTextColorThree,
    tertiaryTextColorFour,
    primaryBorderColorThree,
    primaryBorderColorTwo,
    secondaryTextColorOne,
    secondaryTextColorTwo,
    primaryBackgroundColorOne,
    primaryBorderColorOne,
    tertiaryTextColorFive,
    tertiaryTextColorOne,
    tertiaryTextColorTwo,
    transparent,
    tertiaryBackgroundColorTwo,
    tertiaryBackgroundColorOne,
    tertiaryBackgroundColorThree,
    tertiaryBackgroundColorFour,
    quaternaryBackgroundColorOne,
    primaryBackgroundColorTwo
};
